import axios from '../../../axios';

const url = '/jobsearch/api/monsterlocations/';

export const getMonsterCountries = () => axios.get(`${url}get-countries`);

export const getMonsterStates = (country: string) =>
  axios.get(`${url}get-states?country=${country}`);

export const getMonsterCities = (country: string, state: string) =>
  axios.get(`${url}get-cities?country=${country}&state=${state}`);

export const getMonsterLocations = (searchKey: string, country?: string, criteria?: string) =>
  axios.get(`${url}get-locations?searchKey=${searchKey}&country=${country}&criteria=${criteria}`);
